import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Security } from 'src/app/utils/security.util';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(private plt: Platform) {
  }

  initAppTheme() {
    if (Security.hasTheme()) {
      if (Security.getChangeTheme() === 'true') {
        this.setAppTheme(true);
      } else {
        this.setAppTheme(false);
      }
    } else {
      Security.setChangeTheme(false);
      this.setAppTheme(false);
    }
  }

  setAppTheme(dark) {
    if (dark) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
    Security.setChangeTheme(dark);
  }
}
